import _ from "lodash-es";
import md5 from "js-md5";
import axios, { AxiosRequestConfig } from "axios";
import Config from "@/config/config";
import request, { UploadFile } from "@/lib/request/request";
import Url from "../common/url";
import Path from "@/lib/common/path";
import UploadedFile from "@/lib/model/gateway/uploaded-file";
import PostPolicy from "@/lib/model/gateway/post-policy";
import Auth from "@/lib/common/auth";

class Gateway {
  appCode = "";
  client = "";
  secret = "";

  constructor(appCode: string, client: string, secret: string) {
    this.appCode = appCode;
    this.client = client;
    this.secret = secret;
  }

  sign(timestamp: string) {
    const s = [this.client, this.secret, timestamp].join("|");
    return md5(s);
  }

  url(path: string, query: { [key: string]: string } = {}) {
    const timestamp = String(Math.round(new Date().getTime() / 1000));
    const sign = this.sign(timestamp);
    query = {
      appCode: this.appCode,
      client: this.client,
      timestamp: timestamp,
      sign: sign,
      ...query
    };
    const queryString = Url.buildQuery(query);
    return Path.join(Config.gatewayUrl, path) + "?" + queryString;
  }

  post(path: string, params?: object) {
    const url = this.url(path);
    return request.post(url, params);
  }

  upload(
    policy: PostPolicy,
    file: File,
    config?: AxiosRequestConfig
  ): Promise<UploadedFile> {
    const form = new FormData();
    form.set("OSSAccessKeyId", policy.accessid);
    form.set("policy", policy.policy);
    form.set("Signature", policy.signature);
    form.set("key", policy.dir);
    form.set("file", file);
    form.set("success_action_status", "201");
    if (!config) {
      config = {};
    }
    if (!config.headers) {
      config.headers = { "Content-Type": "multipart/form-data" };
    }
    return axios.post(policy.cdn, form, config).then(() => {
      const uploadedFile = new UploadedFile();
      uploadedFile.object = policy.dir;
      uploadedFile.url = Path.join(policy.cdn, encodeURIComponent(policy.dir));
      uploadedFile.size = file.size;
      uploadedFile.filename = file.name;
      return uploadedFile;
    });
  }

  anonymousUpload(file: File): Promise<UploadedFile> {
    const url = this.url("rc/agent/anonymous/upload");
    const upload = new UploadFile();
    upload.raw = file;
    return request.upload(url, upload).then(resp => {
      return new UploadedFile(resp).assign(resp.data.data);
    });
  }

  anonymousGetPostPolicy(filename: string): Promise<PostPolicy> {
    const url = this.url("rc/agent/anonymous/getPostPolicy", {
      filename: filename
    });
    return request.post(url).then(resp => {
      return new PostPolicy(resp).assign(resp.data.data);
    });
  }
  //上传视频转码前置接口 -获取上传凭证//aiExam/vod/createUploadVideo
  uploadVideoPre(param: {}) {
    //https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6
    return request.post("aiExam/vod/createUploadVideo", param).then(resp => {
      return resp.data.data;
    });
  }

  async ck5Upload(loader: any) {
    const data = new FormData();
    data.append("typeOption", "upload_image");
    // eslint-disable-next-line prefer-const
    let t = await loader.file;
    data.append("upload", t);
    setTimeout(() => {
      //
    }, 8000);
    // eslint-disable-next-line prefer-const
    let a = await new Promise((resolve, reject) => {
      request
        .post(this.url("rc/agent/anonymous/getPostPolicy"), {
          upload: t,
          typeOption: "upload_image"
        })
        .then((res: any) => {
          const resData = res.data;
          resData.default = resData.url;
          resolve(resData);
        })
        .catch((error: any) => {
          reject(error);
        });
    });
    return a;
  }
}

const gateway = new Gateway(Config.appCode, Config.client, Config.secret);

export default gateway;
